<div class="notifications-container">
  <div class="notification-half-container">
    <div class="header">
      <div class="title">
        <span class="title-text">
          {{ 'doktar_app.account.home.notifications' | translate }}
        </span>
        <div class="trailing">
          <i *ngIf="isLoading" class="ph-bold ph-spinner ph-spin" style="margin-right: 8px; color: #6366f1"></i>
          <p-button variant="text" icon="ph-bold ph-dots-three" (onClick)="openActionsPanel($event)" />
        </div>
      </div>
      <p-popover [appendTo]="'body'" #notificationActionsPopover (onShow)="onPopoverShow()" (onHide)="onPopoverHide()">
        <div class="notification-actions-popover">
          @for (item of notificationActions; track item.labelKey) {
            @if (!item.isDisabled) {
              <dk-button
                [label]="item.labelKey | translate"
                severity="contrast"
                [text]="true"
                [outlined]="true"
                size="medium"
                [color]="item.color"
                (onClick)="item.onClick()"></dk-button>
            }
          }
        </div>
      </p-popover>
    </div>

    <div class="notification-body">
      @for (group of notificationGroups; track group.date.toMillis()) {
        <div class="notification-day-container">
          <div class="notification-latest-date">
            <span class="notification-latest-date-text">
              {{ getNotificationGroupDateHeader(group.date) }}
            </span>
          </div>
          <div class="notification-items-container">
            @for (notification of group.notifications; track notification.id) {
              <div
                class="notification-item"
                [class.unread]="!notification.isSeen"
                (click)="openNotificationUrl(notification)">
                <div class="notification-icon">
                  @if (notification.icon && !hasIconError(notification.id)) {
                    <img
                      class="notification-icon-image"
                      [src]="notification.icon"
                      alt=""
                      (error)="onNotificationIconError(notification.id)" />
                  } @else {
                    <i class="ph-fill ph-bell"></i>
                  }
                  @if (!notification.isSeen) {
                    <dk-unread-icon class="unread-red-dot"></dk-unread-icon>
                  }
                </div>
                <div class="notification-content">
                  <div class="notification-header">
                    <span class="notification-title">{{ notification.subject }}</span>
                    <span class="notification-date">
                      {{ notification.createdAt.toJSDate() | date: 'HH:mm' }}
                    </span>
                  </div>
                  <div class="notification-description">
                    {{ notification.notificationContent }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      } @empty {
        @if (!isLoading) {
          <div class="no-notification-container">
            <i class="ph ph-tray"></i>
            <span class="title">
              {{ 'doktar_app.account.notifications.no_notifications' | translate }}
            </span>
            <span class="description">
              {{ 'doktar_app.account.notifications.no_notifications_description' | translate }}
            </span>
          </div>
        }
      }
    </div>
  </div>
</div>
